export default __webpack_public_path__ + "static/media/Group9270.7285ea2a.svg";